import React, { useContext } from 'react'
import { components } from '@digital-commerce/shared-utils'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useCart from '../../../hooks/useCart'
import { getNonIndexedLegalKeys, transformComboCancellationFeeContent } from './utils'
import { isCartValid } from '../../../utils/cart'

const { WithLegal } = components

const NonIndexedLegals = () => {
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const { cart } = useCart()

  if (!cart) return null

  const { legalKeys, hsServices } = getNonIndexedLegalKeys({
    cart,
    isCartValid: isCartValid(cart),
    translate
  })

  const onReceiveContentHandler = hsServices
    ? transformComboCancellationFeeContent(hsServices, lang)
    : null

  return <WithLegal content={legalKeys} onReceiveContent={onReceiveContentHandler} copy={lang} />
}

export default NonIndexedLegals
